module.exports = __webpack_public_path__ + "img/share.3a564943.svg";